/**
 * The search box of an entity picker in the config dialog (knowledge base, channel, LLM model, agent
 * function), with a clear (×) button. The button shows when there is text or a selection to clear.
 * Clicking it calls onClear, which the caller uses to empty the text and the selection together.
 */

import React from 'react';

export interface EntitySearchInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** True when the box holds text or a selected entity. The clear button is shown only then. */
  hasValue: boolean;
  onClear: () => void;
  /** Accessible name for the clear button, for example "Clear LLM model". */
  clearLabel: string;
}

export const EntitySearchInput: React.FC<EntitySearchInputProps> = ({ hasValue, onClear, clearLabel, className, ...inputProps }) => (
  <div className="entity-search-wrap">
    <input type="text" className={`entity-search-input${className ? ` ${className}` : ''}`} {...inputProps} />
    {hasValue && !inputProps.disabled && (
      <button
        type="button"
        className="entity-search-clear"
        aria-label={clearLabel}
        title="Clear"
        // Keep focus in the input so the list does not close before the clear runs.
        onMouseDown={(e) => e.preventDefault()}
        onClick={onClear}
      >
        ×
      </button>
    )}
  </div>
);
